// import { t } from '@lingui/macro'
import { isAuthorized } from 'helpers'

export const getNativeAppsRoutes = (userRoles, navigate) => {
  const has_apps_preview = isAuthorized(userRoles, ['apps_preview', 'admin'])

  return [
    // {
    //   disabled: !has_apps_preview,
    //   label: i18n._(t`Dashboard`),
    //   path: '/nativeapps',
    //   onClick: path => navigate(path)
    // },
    {
      disabled: !has_apps_preview,
      label: 'Radar',
      path: '/nativeapps/radar',
      onClick: path => navigate(path)
    },
    {
      disabled: !has_apps_preview,
      label: 'DoorPilot',
      path: '/nativeapps/doorpilot',
      onClick: path => navigate(path)
    },
    {
      disabled: !has_apps_preview,
      label: 'ScanPilot',
      path: '/nativeapps/scanpilot',
      onClick: path => navigate(path)
    },
    {
      disabled: !has_apps_preview,
      label: 'Ground Control',
      path: '/nativeapps/groundcontrol',
      onClick: path => navigate(path)
    }
  ]
}
